import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useCreateLine = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post("/Line/CreateLine", formData);
  });
  return mutation;
};
export default useCreateLine;
